import { render, staticRenderFns } from "./ModalApoderados.vue?vue&type=template&id=c8ecc844"
import script from "./ModalApoderados.vue?vue&type=script&lang=js"
export * from "./ModalApoderados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8ecc844')) {
      api.createRecord('c8ecc844', component.options)
    } else {
      api.reload('c8ecc844', component.options)
    }
    module.hot.accept("./ModalApoderados.vue?vue&type=template&id=c8ecc844", function () {
      api.rerender('c8ecc844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/infoBase/modales/ModalApoderados.vue"
export default component.exports